import { useState, type JSX } from 'react'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { api } from '../../../api/client.js'
import { isValidE164 } from '../../../utils/e164.js'

export default function DncCheckWidget(): JSX.Element {
  const [phone, setPhone] = useState('')
  const [result, setResult] = useState<{ onDnc: boolean } | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  async function check(): Promise<void> {
    setError(null)
    setResult(null)
    if (!isValidE164(phone)) {
      setError('Enter a valid E.164 number (e.g. +15551234567)')
      return
    }
    setLoading(true)
    try {
      const resp = await api.get<{ onDnc: boolean }>(`/dnc/check?phone=${encodeURIComponent(phone)}`)
      setResult(resp)
    } catch (e) {
      setError((e as Error).message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex items-center gap-2 rounded border p-3">
      <InputText
        aria-label="Phone number to check"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder="+15551234567"
      />
      <Button label="Check" onClick={check} disabled={loading} />
      <span aria-live="polite">
        {result && (
          <span className={result.onDnc ? 'text-red-700' : 'text-green-700'}>
            {result.onDnc ? '✓ On DNC' : '✗ Not on DNC'}
          </span>
        )}
      </span>
      {error && (
        <span className="text-red-600 text-sm" role="alert">
          {error}
        </span>
      )}
    </div>
  )
}
